export default defineNuxtPlugin(() => {
  const { show, hide, state } = useHeaderFix()

  return {
    provide: {
      headerFix: {
        state,
        show,
        hide,
      },
    },
  }
})
